export class FamilyTypeFilter {
    public IncludeInactive?: boolean;
}

export default FamilyTypeFilter;